/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ selected: NonNullable<unknown>, total: NonNullable<unknown> }} Team_Share_Access_PartialInputs */



/**
* | output |
* | --- |
* | "{selected} of {total} event groups" |
*
* @param {Team_Share_Access_PartialInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_share_access_partial = /** @type {((inputs: Team_Share_Access_PartialInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Share_Access_PartialInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`${i?.selected} of ${i?.total} event groups`)
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.selected} of ${i?.total} event groups`)
	if (locale === "it") return /** @type {LocalizedString} */ (`${i?.selected} of ${i?.total} event groups`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`${i?.selected} of ${i?.total} event groups`)
	if (locale === "es") return /** @type {LocalizedString} */ (`${i?.selected} of ${i?.total} event groups`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`${i?.selected} of ${i?.total} event groups`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`${i?.selected} of ${i?.total} event groups`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`${i?.selected} of ${i?.total} event groups`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`${i?.selected} of ${i?.total} event groups`)
	return /** @type {LocalizedString} */ (`${i?.selected} of ${i?.total} event groups`)
});